import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col",
  style: {"width":"100%"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "voucher-title-wrapper" }
const _hoisted_5 = { class: "voucher-title-hotel" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_9 = { class: "hotel-address-info" }
const _hoisted_10 = { class: "hotel-service-info mta4-3" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "hotel-voucher-detail mta4-3" }
const _hoisted_13 = { class: "your-voucher-detail mt-3" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "d-flex" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 3 }
const _hoisted_30 = {
  key: 4,
  class: "meal-plan-hotel"
}
const _hoisted_31 = {
  key: 5,
  class: "meal-plan-hotel"
}
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 6 }
const _hoisted_38 = {
  key: 0,
  class: "hotel-voucher-transport mta4-3"
}
const _hoisted_39 = { class: "transport-to-hotel" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_45 = {
  key: 0,
  cellspacing: "15"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "3",
    style: {"text-align":"right","font-weight":"bold"}
  }, "every"),
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "2",
    style: {"text-align":"right","font-weight":"bold"}
  }, "every"),
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "2",
    style: {"text-align":"right","font-weight":"bold"}
  }, "every")
], -1)
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { style: {"font-weight":"bold"} }
const _hoisted_49 = {
  key: 1,
  class: "hotel-voucher-general-comment mta4-3"
}
const _hoisted_50 = { class: "general-comment" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = {
  key: 2,
  class: "hotel-voucher-general-comment mta4-3"
}
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = { class: "hotel-voucher-billing-inf mta4-3" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_61 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_62 = { key: 0 }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_64 = { key: 0 }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_66 = { key: 0 }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_68 = { key: 0 }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_70 = ["innerHTML"]
const _hoisted_71 = { key: 0 }
const _hoisted_72 = ["innerHTML"]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_col = _resolveComponent("el-col")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hotelData, (data, index) => {
    return (_openBlock(), _createElementBlock("div", { key: index }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.detail, (dataDetail, indexDetail) => {
        return (_openBlock(), _createElementBlock("div", {
          key: indexDetail,
          class: "pagebreak"
        }, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      (_ctx.getLinkImgVoucher(_ctx.hotelLanguage[index], 'linkLogo', _ctx.showSecondLanguage))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("div", {
                              class: "voucher-logo",
                              style: _normalizeStyle(
                  'float:' +
                  ((_ctx.hotelLanguage[index].paxLang.posLogo ?? _ctx.hotelLanguage[index].enLang.posLogo) == 'fleft' ? 'left' : 'right')
                )
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.getLinkImgVoucher(_ctx.hotelLanguage[index], 'linkLogo', _ctx.showSecondLanguage),
                                width: "300"
                              }, null, 8, _hoisted_2)
                            ], 4)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_row, { class: "hotel-voucher-title-cont" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            (_ctx.getLinkImgVoucher(_ctx.hotelLanguage[index], 'linkIcon', _ctx.showSecondLanguage))
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  alt: "",
                                  src: _ctx.getLinkImgVoucher(_ctx.hotelLanguage[index], 'linkIcon', _ctx.showSecondLanguage),
                                  width: "35"
                                }, null, 8, _hoisted_6))
                              : _createCommentVNode("", true),
                            _createElementVNode("strong", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                              }, _toDisplayString(_ctx.hotelLanguage[index].enLang.row1), 3),
                              (_ctx.showSecondLanguage)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_7, "‎‏/‎‏ " + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row1), 1))
                                : _createCommentVNode("", true),
                              _hoisted_8
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", null, _toDisplayString(data.name), 1),
                    _createElementVNode("p", null, _toDisplayString(data.address), 1),
                    _createElementVNode("p", null, _toDisplayString(data.zipcode + ', ' + data.city), 1),
                    _createElementVNode("p", {
                      class: _normalizeClass(["phone-pax", _ctx.langPaxDirection == 'rtl' ? 'align-right' : ''])
                    }, _toDisplayString(data.telephone), 3)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("strong", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                      }, _toDisplayString(_ctx.hotelLanguage[index].enLang.hotelservices), 3),
                      (_ctx.showSecondLanguage)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_11, " ‎‏/‎‏ " + _toDisplayString(_ctx.hotelLanguage[index].paxLang.hotelservices), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("p", null, " - Wifi: " + _toDisplayString(data.id_other_service?.freewifi > 0 ? (data.id_other_service?.freewifi === 1 ? 'Free' : 'Payed') : 'No'), 1),
                    _createElementVNode("p", null, "- Handicapped: " + _toDisplayString(data.id_other_service?.handicapped ? 'Yes' : 'No'), 1),
                    _createElementVNode("p", null, "- Pets: " + _toDisplayString(data.id_other_service?.dog ? 'Yes' : 'No'), 1),
                    _createElementVNode("p", null, "- Baby: " + _toDisplayString(data.id_other_service?.baby ? 'Yes' : 'No'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, [
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                      }, _toDisplayString(_ctx.hotelLanguage[index].enLang.row2), 3),
                      (_ctx.showSecondLanguage)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_14, "‎‏/‎‏" + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row2), 1))
                        : _createCommentVNode("", true),
                      _hoisted_15
                    ]),
                    _hoisted_16,
                    _createElementVNode("p", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                      }, _toDisplayString(_ctx.hotelLanguage[index].enLang.row3), 3),
                      (_ctx.showSecondLanguage)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_17, "‎‏/‎‏" + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row3), 1))
                        : _createCommentVNode("", true),
                      _createTextVNode(" ‎‏:‎‏ " + _toDisplayString(data.pax_name), 1)
                    ]),
                    _createElementVNode("p", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                      }, _toDisplayString(_ctx.hotelLanguage[index].enLang.row4), 3),
                      (_ctx.showSecondLanguage)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_18, " ‎‏/‎‏ " + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row4), 1))
                        : _createCommentVNode("", true),
                      _createTextVNode("‎‏:‎‏ " + _toDisplayString(dataDetail.code), 1)
                    ]),
                    (dataDetail.ws_booking && dataDetail.ws_booking.BookingReference)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                          }, _toDisplayString(_ctx.hotelLanguage[index].enLang.row53), 3),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_20, "‎‏/‎‏" + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row53), 1))
                            : _createCommentVNode("", true),
                          _createTextVNode("‎‏:‎‏ HRS " + _toDisplayString(dataDetail.ws_booking.reservationProcessKey), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("p", {
                        innerHTML: _ctx.languageReplace(_ctx.hotelLanguage[index].enLang.row5, { ['<number>']: data.countPax }),
                        class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                      }, null, 10, _hoisted_22),
                      (_ctx.showSecondLanguage)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: "pl-2",
                            innerHTML: 
                  _ctx.languageReplace(' ‎‏/‎‏ ' + _ctx.hotelLanguage[index].paxLang.row5, {
                    ['<number>']: data.countPax
                  })
                
                          }, null, 8, _hoisted_23))
                        : _createCommentVNode("", true),
                      _hoisted_24
                    ]),
                    (dataDetail.isCombineHotelVoucher)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 1,
                          class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : ''),
                          innerHTML: _ctx.generateTextVoucherTimeEntitled(dataDetail, _ctx.hotelLanguage[index], true)
                        }, null, 10, _hoisted_25))
                      : (_openBlock(), _createElementBlock("p", {
                          key: 2,
                          class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : ''),
                          innerHTML: _ctx.generateTextVoucherTimeEntitled(dataDetail, _ctx.hotelLanguage[index], false)
                        }, null, 10, _hoisted_26)),
                    _createElementVNode("p", null, [
                      _hoisted_27,
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                      }, _toDisplayString(_ctx.hotelLanguage[index].enLang.row64), 3),
                      (_ctx.showSecondLanguage)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_28, " ‎‏/‎‏" + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row64), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (data.checkout_time)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, "  Check-out‎‏:‎‏ " + _toDisplayString(data.checkout_time), 1))
                      : _createCommentVNode("", true),
                    (!_ctx.isOldMealPlan)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedMealPlan[index], (mealText, mealIndex) => {
                            return (_openBlock(), _createElementBlock("div", { key: mealIndex }, [
                              _createElementVNode("p", null, "- " + _toDisplayString(mealText), 1)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          (_ctx.processedMealPlan[index].length > 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                (_ctx.isOldMealPlan)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                                    }, [
                                      _createTextVNode(_toDisplayString(_ctx.hotelLanguage[index].enLang.row68) + " ", 1),
                                      (_ctx.showSecondLanguage)
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_33, " ‎‏/‎‏" + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row68), 1))
                                        : _createCommentVNode("", true),
                                      _hoisted_34
                                    ], 2))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedMealPlan[index], (mealText, mealIndex) => {
                                  return (_openBlock(), _createElementBlock("div", { key: mealIndex }, [
                                    _createElementVNode("p", null, "- " + _toDisplayString(mealText), 1)
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                                }, [
                                  _createTextVNode(_toDisplayString(_ctx.hotelLanguage[index].enLang.row68) + " ", 1),
                                  (_ctx.showSecondLanguage)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_36, " ‎‏/‎‏ " + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row68), 1))
                                    : _createCommentVNode("", true),
                                  _createTextVNode("‎‏:‎‏ " + _toDisplayString(_ctx.processedMealPlan[index][0]), 1)
                                ], 2)
                              ]))
                        ])),
                    (_ctx.mealPlanText)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_37, "- " + _toDisplayString(_ctx.mealPlanText), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (data.transport_available && data.transport_id == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("p", _hoisted_39, [
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                          }, _toDisplayString(_ctx.hotelLanguage[index].enLang.row50), 3),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_40, " ‎‏/‎‏" + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row50), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                          }, _toDisplayString(_ctx.hotelLanguage[index].enLang.row17), 3),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_41, " ‎‏/‎‏" + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row17), 1))
                            : _createCommentVNode("", true),
                          _createTextVNode(" ‎‏:‎‏ " + _toDisplayString(data.transport_available ? 'Yes' : 'No'), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                          }, _toDisplayString(_ctx.hotelLanguage[index].enLang.row33), 3),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_42, " ‎‏/‎‏" + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row33), 1))
                            : _createCommentVNode("", true),
                          _createTextVNode(" ‎‏:‎‏ " + _toDisplayString(data.transport_complementary ? 'Yes' : 'No'), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                          }, _toDisplayString(_ctx.hotelLanguage[index].enLang.row34.replace(':', '')), 3),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_43, " ‎‏/‎‏ " + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row34.replace(':', '')), 1))
                            : _createCommentVNode("", true),
                          _hoisted_44
                        ]),
                        (data.operating_time.length)
                          ? (_openBlock(), _createElementBlock("table", _hoisted_45, [
                              _createElementVNode("tbody", null, [
                                _hoisted_46,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.operating_time, (transportData, day) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: day }, [
                                    (transportData.status)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_47, [
                                          _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.dayMap[day]) + ":", 1),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transportData.data, (transportTime, key) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                              _createElementVNode("td", null, _toDisplayString(transportTime.operating_opentime || '') + " - " + _toDisplayString(transportTime.operating_closetime || ''), 1),
                                              _createElementVNode("td", null, _toDisplayString(transportTime.frequency_service || '') + " min", 1)
                                            ], 64))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (dataDetail.comment || dataDetail.comment_airline)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _createElementVNode("p", _hoisted_50, [
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                          }, _toDisplayString(_ctx.hotelLanguage[index].enLang.row10), 3),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_51, "‎‏/‎‏" + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row10), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("p", null, _toDisplayString(dataDetail.comment_airline), 1),
                        _createElementVNode("p", {
                          class: "hotel-comment",
                          innerHTML: _ctx.linkify(dataDetail.comment)
                        }, null, 8, _hoisted_52)
                      ]))
                    : _createCommentVNode("", true),
                  (dataDetail.ws_booking && dataDetail.ws_booking.BookingReference)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        (_ctx.hotelLanguage[index].enLang && _ctx.hotelLanguage[index].enLang.row76)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_54, [
                              _createElementVNode("span", {
                                class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                              }, _toDisplayString(_ctx.hotelLanguage[index].enLang.row76), 3),
                              (_ctx.showSecondLanguage)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_55, " ‎‏/‎‏" + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row76), 1))
                                : _createCommentVNode("", true),
                              _createTextVNode(" ‎‏:‎‏ " + _toDisplayString(dataDetail.ws_booking.BookingReference ? 'HRS' : 'SFS360'), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                          }, _toDisplayString(_ctx.hotelLanguage[index].enLang.row41 || 'Reservation Number'), 3),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_56, " ‎‏/‎‏ " + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row41 || 'Reservation Number'), 1))
                            : _createCommentVNode("", true),
                          _createTextVNode(" ‎‏:‎‏ " + _toDisplayString(dataDetail.ws_booking.BookingReference), 1)
                        ]),
                        (_ctx.hotelLanguage[index].enLang && _ctx.hotelLanguage[index].enLang.row78)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 1,
                              innerHTML: _ctx.getVHtmlContentHRSSupport(_ctx.hotelLanguage[index], dataDetail)
                            }, null, 8, _hoisted_57))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("strong", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                      }, _toDisplayString(_ctx.hotelLanguage[index].enLang.row42), 3),
                      (_ctx.showSecondLanguage)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_59, [
                            _createElementVNode("span", null, " ‎‏/‎‏" + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row42), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_60
                    ]),
                    _hoisted_61,
                    _createElementVNode("strong", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                      }, _toDisplayString(_ctx.hotelLanguage[index].enLang.row43), 3),
                      (_ctx.showSecondLanguage)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_62, [
                            _createElementVNode("span", null, " ‎‏/‎‏" + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row43), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" ‎‏:‎‏ " + _toDisplayString(_ctx.flightNumber), 1)
                    ]),
                    _hoisted_63,
                    _createElementVNode("strong", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                      }, _toDisplayString(_ctx.hotelLanguage[index].enLang.row57), 3),
                      (_ctx.showSecondLanguage)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_64, [
                            _createElementVNode("span", null, " ‎‏/‎‏" + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row57), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" ‎‏:‎‏ " + _toDisplayString(_ctx.flightDate), 1)
                    ]),
                    _hoisted_65,
                    _createElementVNode("strong", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                      }, _toDisplayString(_ctx.hotelLanguage[index].enLang.row44), 3),
                      (_ctx.showSecondLanguage)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_66, [
                            _createElementVNode("span", null, " ‎‏/‎‏" + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row44), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" ‎‏:‎‏ " + _toDisplayString(dataDetail.blockcode), 1)
                    ]),
                    _hoisted_67,
                    _createElementVNode("strong", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                      }, _toDisplayString(_ctx.hotelLanguage[index].enLang.row45), 3),
                      (_ctx.showSecondLanguage)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_68, [
                            _createElementVNode("span", null, " ‎‏/‎‏" + _toDisplayString(_ctx.hotelLanguage[index].paxLang.row45), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" ‎‏:‎‏ " + _toDisplayString(dataDetail.code), 1)
                    ]),
                    _hoisted_69,
                    _createElementVNode("strong", {
                      innerHTML: _ctx.languageReplace(_ctx.hotelLanguage[index].enLang.row55, { ['<count_pax>']: data.countPax }),
                      class: _normalizeClass(_ctx.showSecondLanguage ? 'pml-2' : '')
                    }, null, 10, _hoisted_70),
                    (_ctx.showSecondLanguage)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_71, [
                          _createElementVNode("i", null, [
                            _createElementVNode("span", {
                              innerHTML: 
                    _ctx.languageReplace(' ‎‏/‎‏ ' + _ctx.hotelLanguage[index].paxLang.row55, {
                      ['<count_pax>']: data.countPax
                    })
                  
                            }, null, 8, _hoisted_72)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_73,
                    _createElementVNode("strong", null, _toDisplayString(data.voucher_vat_comment_line), 1)
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128))
    ]))
  }), 128))
}